"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Z-Index theme values.
 *
 * Currently, we simply set those used by controls individually, but we endevour
 * to eventually have a naming scheme that's similar to that used elsewhere:
 *
 * See https://github.com/allenai/varnish/issues/153.
 */
exports.zIndex = {
    fixedTable: 'auto',
    bgLayer1: 1,
    bgLayer2: 2,
    bgLayer3: 3,
    bgLayer4: 4,
    bgLayer5: 5,
    bgLayer6: 6,
    bgLayer7: 7,
    bgLayer8: 8,
    bgLayer9: 9,
    bgLayer10: 10,
    backTop: 10,
    affix: 10,
    badge: 10,
    pickerPanel: 10,
    popupClose: 10,
    header: 950,
    modal: 1000,
    modalMask: 1000,
    message: 1010,
    notification: 1010,
    popover: 1030,
    dropdown: 1050,
    picker: 1050,
    tooltip: 1060
};
//# sourceMappingURL=zIndex.js.map